type TUserRoutes = 'profile' | 'profile_general' | 'profile_roles' | 'profile_security';

export const userRoutes = <Record<TUserRoutes, string>>{
    profile: 'profile',
    profile_general: 'general',
    profile_security: 'security',
    profile_roles: 'roles'
};
